import React from 'react';
import Tooltip from 'material-ui/Tooltip';

import Console from '../../../../lib/debug';

export default class MegaDropTag extends React.Component {
    handleTags(tag) {
        this.props.handleTags(tag);
    }
    render() {
        Console.render('designer.MegaDropTag');
        let theTag = null;
        let clickable = this.props.clickable || false;
        let removable = this.props.removable || false;
        let tag = this.props.tag;
        let title = tag ? tag.title : this.props.content;
        let tagClasses = `ex-tag${clickable ? ' clickable' : ''}${
            removable ? ' removable' : ''
        }${this.props.content ? ' ex-tag-all' : ''}`;
        if (removable) {
            theTag = (
                <Tooltip title={title}>
                    <span className={tagClasses} data-for="MegaDrop">
                        <span
                            className="mdi mdi-close"
                            onClick={this.handleTags.bind(this, tag)}
                        />
                        <span className="MDTag-title">{title}</span>
                    </span>
                </Tooltip>
            );
        } else if (clickable) {
            theTag = (
                <span
                    className={tagClasses}
                    onClick={this.handleTags.bind(this, tag)}
                >
                    <span className="MDTag-title">{title}</span>
                </span>
            );
        } else {
            theTag = (
                <span className={tagClasses}>
                    <span className="MDTag-title">{title}</span>
                </span>
            );
        }
        return theTag;
    }
}
